export default "__VITE_ASSET__2LomKJaB__"